import { render, staticRenderFns } from "./ContractorComments.vue?vue&type=template&id=f0802a9c&scoped=true"
import script from "./ContractorComments.vue?vue&type=script&lang=js"
export * from "./ContractorComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0802a9c",
  null
  
)

export default component.exports